/* eslint-disable */
import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    TextField,
    Button,
    Stack,
    MenuItem,
    Grid
} from '@material-ui/core';
import * as Yup from 'yup';
import { trackPromise } from 'react-promise-tracker';
import Services from '../Service';
import { ToastContainer, toast } from 'react-toastify';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { normalizeQuantityValue } from './quantityUtils';

export default function FreshCutSKUsDialog({ open, setOpen, setFreshCutSKUsRows, isUpdate, freshCutSKUsRows, index }) {

    const [productcatogery, setProductcatogery] = useState([]);
    const [freshCutSKUsDetails, setFreshCutSKUsDetails] = useState([]);
    const [formData, setFormData] = useState({
        productCategoryID: 0,
        productID: 0,
        quantity: ''
    });
    const batchDialogSchema = Yup.object().shape({
        productCategoryID: Yup.number().min(1, 'Please Select Product Category').required('Product Category Required'),
        productID: Yup.number().min(1, 'Please Select Cut SKU').required('Cut SKU Required'),
        quantity: Yup.number()
            .typeError('Quantity must be a number')
            .min(0.01, 'Please Enter Quantity')
            .required('Quantity required')
            .test('decimal-places', 'Quantity cannot have more than 3 decimal places', function(value) {
                if (!value) return true;
                const decimalPlaces = (value.toString().split('.')[1] || []).length;
                return decimalPlaces <= 3;
            })
    });

    const handleQuantityChange = (e) => {
        let value = e.target.value;

        if (value === '' || value === '.') {
            formik.setFieldValue('quantity', value);
            return;
        }

        if (!/^\d*\.?(?:\d{0,3})?$/.test(value)) {
            return;
        }

        const parts = value.split('.');
        if (parts.length > 2) {
            return;
        }

        if (parts[1] && parts[1].length > 3) {
            value = parts[0] + '.' + parts[1].slice(0, 3);
        }

        formik.setFieldValue('quantity', value);
    };

    const formik = useFormik({
        initialValues: {
            productCategoryID: formData.productCategoryID,
            productID: formData.productID,
            quantity: formData.quantity
        },
        validationSchema: batchDialogSchema,
        onSubmit: (values) => {
            AddBatchDetails(values)
        }
    });
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(GetProductCategoties());
        if (isUpdate == true) {
            setValues((prevState) => ({
                ...prevState,
                productCategoryID: freshCutSKUsRows[index].productCategoryID,
                productID: freshCutSKUsRows[index].productID,
                quantity: freshCutSKUsRows[index].quantity
            }));
        }
    }, []);

    useEffect(() => {
        if (values.productCategoryID != 0) {
            trackPromise(GetFreshCutSKUsDetails(values.productCategoryID));
        }
    }, [values.productCategoryID]);

    async function GetProductCategoties() {
        var res = await Services.GetProductCategotiesForDropDown()
        if (res != null) {
            setProductcatogery(res);
        }
    }

    async function GetFreshCutSKUsDetails(productCategoryID) {
        var res = await Services.GetFreshCutSKUsDetails(productCategoryID)
        if (res != null) {
            setFreshCutSKUsDetails(res);
        }
    }

    async function AddBatchDetails(values) {
        const selectedSku = freshCutSKUsDetails.find(x => x.productID == values.productID);
        if (isUpdate == false) {
            const found = freshCutSKUsRows.find(x => x.productID == values.productID)
            if (found) {
                toast.warning("Fresh Cut SKU already added");
                return;
            }
            if (selectedSku != null) {
                setFreshCutSKUsRows((prev) =>
                    [...prev, {
                        productCategoryID: values.productCategoryID,
                        productID: selectedSku.productID,
                        productCode: selectedSku.productCode,
                        productName: selectedSku.productName,
                        measuringUnit: selectedSku.measuringUnitID,
                        details: selectedSku.details,
                        quantity: normalizeQuantityValue(values.quantity)
                    }]);
                setOpen(false);
            }
        } else {
            setFreshCutSKUsRows((prev) => prev.map((row, i) => i === index ? { ...row, quantity: normalizeQuantityValue(values.quantity) } : row));
            setOpen(false);
        }
    }

    const handleClose = () => {
        setOpen(false);
        setFreshCutSKUsDetails([]);
        setValues((prevState) => ({
            ...prevState,
            productCategoryID: 0,
            productID: 0,
            quantity: ''
        }));
    };

    function generateProductCategoryDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(x.isActive == true ? <MenuItem key={x.productCategoryID} value={x.productCategoryID}>{x.productCategoryName}</MenuItem> : null)
            });
        }
        return items
    }

    return (
        <>
            <ToastContainer
                position="bottom-right"
                pauseOnHover
            />
            <Dialog
                fullWidth
                maxWidth='md'
                open={open}
                onClose={handleClose}
                aria-labelledby="max-width-dialog-title"
            >
                <DialogTitle id="max-width-dialog-title">{isUpdate ? 'Update' : 'Add'} Fresh Cut Product</DialogTitle>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <DialogContent>
                            <DialogContentText>

                            </DialogContentText>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Product Category *"
                                            value={formik.values.productCategoryID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('productCategoryID')}
                                            error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                                            helperText={touched.productCategoryID && errors.productCategoryID}
                                            InputProps={{
                                                readOnly: isUpdate == true ? true : false
                                            }}
                                        >
                                            <MenuItem key={0} value={0}> Select Product Category</MenuItem>
                                            {generateProductCategoryDropDownMenu(productcatogery)}
                                        </TextField>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <Autocomplete
                                            size="small"
                                            options={freshCutSKUsDetails}
                                            disabled={isUpdate == true ? true : false}
                                            getOptionLabel={(option) => `${option.productCode} - ${option.productName}`}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    label="Fresh Cut Product *"
                                                    variant="outlined"
                                                    size="small"
                                                    disabled={isUpdate == true ? true : false}
                                                    error={Boolean(touched.productID && errors.productID)}
                                                    helperText={touched.productID && errors.productID}
                                                />
                                            )}
                                            value={freshCutSKUsDetails.find((item) => item.productID === values.productID) || null}
                                            onChange={(event, newValue) => {
                                                setValues((prev) => ({
                                                    ...prev,
                                                    productID: newValue ? newValue.productID : 0
                                                }));
                                            }}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            fullWidth
                                            size='small'
                                            label="Quantity(Kg) *"
                                            value={formik.values.quantity}
                                            {...getFieldProps('quantity')}
                                            onChange={handleQuantityChange}
                                            error={Boolean(touched.quantity && errors.quantity)}
                                            helperText={touched.quantity && errors.quantity}
                                            InputProps={{
                                                inputProps: {
                                                    step: 0.001,
                                                    min: 0.01,
                                                    inputMode: 'decimal',
                                                    pattern: '[0-9]*',
                                                    type: 'number',
                                                    style: {
                                                        textAlign: 'right',
                                                    },
                                                },
                                            }}
                                            onKeyDown={(evt) =>
                                                ['-', '+', 'e', 'E'].includes(evt.key) && evt.preventDefault()
                                            }
                                            onPaste={(evt) => {
                                                const pastedValue = evt.clipboardData.getData('Text');
                                                if (!/^\d*\.?(?:\d{0,3})?$/.test(pastedValue)) {
                                                    evt.preventDefault();
                                                }
                                            }}
                                            onWheel={event => event.target.blur()}
                                            textAlign='right'
                                        />
                                    </Grid>
                                </Stack>
                            </Stack>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                Close
                            </Button>
                            <Button type="submit" color="primary">
                                {isUpdate ? 'Update' : 'Add'}
                            </Button>
                        </DialogActions>
                    </Form>
                </FormikProvider>
            </Dialog>
        </>
    );
}
